import { formatLocalDate } from './date';

export const ADMIN_TIME_ZONE = 'America/Puerto_Rico';
export const ADMIN_TIME_ZONE_OFFSET = '-04:00';

export const normalizePhone = (phone = '') => phone.replace(/[^0-9]/g, '');

export const getAdminISODate = (offsetDays = 0, timeZone = ADMIN_TIME_ZONE) => {
  const now = new Date();
  const localeString = now.toLocaleString('en-US', { timeZone });
  const adminDate = new Date(localeString);
  adminDate.setHours(0, 0, 0, 0);
  adminDate.setDate(adminDate.getDate() + offsetDays);
  return formatLocalDate(adminDate);
};

export const getAdminNow = (timeZone = ADMIN_TIME_ZONE) => (
  new Date(new Date().toLocaleString('en-US', { timeZone }))
);

export const toAdminDateTime = (date, time = '00:00', timeZoneOffset = ADMIN_TIME_ZONE_OFFSET) => {
  if (!date) return null;
  const safeTime = time || '00:00';
  return new Date(`${date}T${safeTime}:00${timeZoneOffset}`);
};

export const getWaiterName = (waiters, waiterId) => {
  if (!waiterId) return 'Sin asignar';
  const waiter = waiters.find((item) => item.id === waiterId);
  return waiter ? waiter.name : 'Sin asignar';
};

export const matchesSection = (sectionName, filter) => {
  if (!filter || filter === 'all') return true;
  if (filter === '__no-section') {
    return !sectionName;
  }
  return sectionName === filter;
};

export const matchesGroupSection = (group, filter) => {
  if (!filter || filter === 'all') return true;
  if (!group?.sections?.length) return true;
  if (filter === '__no-section') {
    return group.sections.includes('__no-section');
  }
  return group.sections.includes(filter);
};

export const isSameReservationDay = (reservationDate, resourceDate) => {
  if (!reservationDate || !resourceDate) return false;
  return reservationDate === resourceDate;
};

export const tableCanBeUsedForReservation = (table, reservation) => {
  if (!reservation?.id) return table.status === 'available';
  if (table.currentReservation?.reservationId === reservation.id) return true;
  if (table.status !== 'assigned') return true;
  return !isSameReservationDay(reservation.date, table.currentReservation?.date);
};

export const groupCanBeUsedForReservation = (group, reservation) => {
  if (!reservation?.id) return group.status === 'available';
  if (group.currentReservation?.reservationId === reservation.id) return true;
  if (group.status !== 'assigned') return true;
  return !isSameReservationDay(reservation.date, group.currentReservation?.date);
};

export const quickGroupSelection = (reservation) => reservation?.quickGroupTables || [];

export const calculateQuickGroupCapacity = (reservation, tables) => {
  const selection = quickGroupSelection(reservation);
  if (!selection.length) return 0;
  return selection.reduce((sum, tableId) => {
    const table = tables.find((item) => item.id === tableId);
    return sum + Number(table?.capacity || 0);
  }, 0);
};

export const extractScannedId = (result) => {
  if (!result) return '';
  if (typeof result === 'string') return result.trim();
  if (typeof result.data === 'string') return result.data.trim();
  return '';
};
